'use client'
import { I18NText } from '@/components/I18NText'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { logout } from '@/lib/auth/logout'
import { useRouter } from '@/lib/useRouter'

export const LogoutButton = () => {
	const router = useRouter()

	const onLogout = async () => {
		window.HubSpotConversations?.widget?.remove()
		await logout(false)
		router.push('/sign-in')
	}

	return (
		<DropdownMenuItem onClick={onLogout}>
			<I18NText text="navbar.menu.logout" />
		</DropdownMenuItem>
	)
}
